import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "react-lazy-load-image-component/src/effects/black-and-white.css";
import "react-lazy-load-image-component/src/effects/opacity.css";

const Image = ({
  src,
  width,
  height,
  alt,
  effect,
  classes,
  fill = false,
  showErrorImage = false,
  showLoadingState = false,
  loadingComponent = null,
  onError = () => {},
  onLoad = () => {},
}) => {
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleError = (e) => {
    setHasError(true);
    setIsLoading(false);
    onError(e);
  };

  const handleLoad = (e) => {
    setIsLoading(false);
    onLoad(e);
  };

  if (hasError || !src) {
    return (
      <div
        className={`w-full h-full bg-md-pink-dark flex items-center justify-center text-white text-center p-4 ${classes}`}
        style={{ width, height }}
      >
        <span className="text-2xl font-medium">
          {alt || "Image unavailable"}
        </span>
      </div>
    );
  }

  const isBlobUrl = typeof src === 'string' && src.startsWith('blob:');

  return (
    // `fill` makes this wrapper adopt the parent's box. Without it the wrapper
    // has no definite height, so an `h-full` img resolves to `auto` and renders
    // at its natural aspect — silently defeating object-cover. Opt-in: most
    // callers (logos, banners) rely on the wrapper sizing to its content.
    <div
      className={`relative${fill ? " w-full h-full" : ""}`}
      style={{ width, height }}
    >
      {showLoadingState && isLoading && (
        loadingComponent || (
          <div
            className={`absolute inset-0 bg-gray-200 animate-pulse rounded ${classes}`}
            style={{ width, height }}
          />
        )
      )}

      <LazyLoadImage
        key={src}
        onError={handleError}
        afterLoad={handleLoad}
        src={src}
        width={width}
        height={height}
        alt={alt}
        effect={effect}
        className={`w-full h-full ${classes} ${isLoading && showLoadingState ? "opacity-0" : "opacity-100"} transition-opacity duration-300`}
        crossOrigin={isBlobUrl ? undefined : 'anonymous'}
      />
    </div>
  );
};

export default Image;